const Title = ({title, show}) => {
    return <h3 className="fw-bold text-dark">{title}</h3>
}

export default Title